export default __webpack_public_path__ + "static/media/accent_3.eb398abb.png";